import { CustomAxiosRequestConfig } from "@xt/xtbase";
import axios from "utils/axios";

const URL = "/uaapi/user/";
const NEW_URL = "/uaapi/account/";

//获取国家相关信息
export function get_countryInfos(query: string, config?: CustomAxiosRequestConfig) {
  return axios.get(URL + `user/country/countryInfos${query}`, config);
}

//根据国家id和语言获取广告页
export function get_advertising(countryId: string, config?: CustomAxiosRequestConfig) {
  return axios.get(URL + `user/advertising/${countryId}`, config);
}

//判断当前ip所属国家是否拦截注册
export function get_checkCountryIpIsIntercept(config?: CustomAxiosRequestConfig) {
  return axios.get(URL + `user/country/checkCountryIpIsIntercept`, config);
}

//校验邀请码是否正确
export function get_checkRecommendCode(code: number, config?: CustomAxiosRequestConfig) {
  return axios.get(URL + `user/checkRecommendCode/${code}`, config);
}

//发送短信邮箱验证码
export function post_msgDoSendCode(config?: CustomAxiosRequestConfig) {
  return axios.post(URL + `msg/doSendCode`, null, config);
}

//用户注册
export function post_reg(config?: CustomAxiosRequestConfig) {
  return axios.post(URL + `reg`, null, config);
}

//用户注册v2
export function post_v2Reg(config?: CustomAxiosRequestConfig) {
  return axios.post(URL + `v2/reg`, null, config);
}

//2fa校验 校验成功获取结果凭证
export function get_faCheckToken(config?: CustomAxiosRequestConfig) {
  return axios.get(URL + `user/fa/getFaResult`, config);
}

//用户通过2fa验证找回密码
// export function put_retrieveThePasswordByFa(config) {
//   return axios.put(URL + `user/retrieveThePasswordByFa`, null, config);
// }
//用户通过2fa验证找回密码
export function put_nResetPasswd(config?: CustomAxiosRequestConfig) {
  return axios.put(URL + `user/fa/item/resetPasswd`, null, config);
}

//找回密码前置校验通过后下发2fa验证项以及优先级
// export function get_retrieveThePasswordByFaBeforeCheck(config) {
//   return axios.get(URL + `user/retrieveThePasswordByFaBeforeCheck`, config);
// }
//找回密码前置校验通过后下发2fa验证项以及优先级
export function get_getFaCheckItem(config?: CustomAxiosRequestConfig) {
  return axios.get(URL + `user/fa/getFaCheckItem`, config);
}

//获取用户基本信息
export function get_userGetUserInfo(config?: CustomAxiosRequestConfig) {
  return axios.get(NEW_URL + `info`, config);
}
// 老版 获取用户基本信息

export function getUserInfo(config?: CustomAxiosRequestConfig) {
  return axios.get(URL + `user/getUserInfo`, config);
}

//获取用户认证信息
export function get_kycGetRealAuthInfo(config?: CustomAxiosRequestConfig) {
  return axios.get(URL + `user/kyc/getRealAuthInfo`, config);
}

//补全用户常住国家信息
export function post_addUserCountry(config: CustomAxiosRequestConfig) {
  return axios.post(URL + `/user/addUserCountry/${config.params.countryId}`, null, config);
}

//获取用户安全等级
export function getSecurityLevel(config?: any) {
  return axios.get(URL + `user/fa/item/getSecurityLevel`, config);
}

//用户邮箱认证
export function put_userDoAuthEmail(config?: CustomAxiosRequestConfig) {
  return axios.put(URL + `user/doAuthEmail`, null, config);
}

//查询kyc信息
export function get_resetKycInfo(config?: CustomAxiosRequestConfig) {
  return axios.get(URL + `user/fa/item/getResetKycInfo`, config);
}

//2fa校验 效验成功获取结果凭证
export function get_faResult(config?: CustomAxiosRequestConfig) {
  return axios.get(URL + `user/fa/getFaResult`, config);
}

//重置fa验证项，当有需要认证手机号与邮箱时调用
export function resetFaItemAuth(config?: CustomAxiosRequestConfig) {
  return axios.post(URL + `user/fa/item/resetFaItemAuth`, null, config);
}

//重置fa验证项，通过faBizType来判断是否需要登录
export function resetFaItem(config?: CustomAxiosRequestConfig) {
  return axios.post(URL + `user/fa/item/resetFaItem`, null, config);
}

//获取谷歌密钥
export function get_userGetGoogleSecret(config?) {
  return axios.get(URL + `user/getGoogleSecret`, config);
}

// 子账户绑定谷歌
export function post_subBindGoogleAuth(config?) {
  return axios.post(URL + `user/sub-account/bind/google`, null, config);
}

// 子账户解绑谷歌
export function post_subUnBindGoogleAuth(config?) {
  return axios.post(URL + `user/sub-account/unbind/google`, null, config);
}

//2fa  绑定谷歌
export function post_bindGoogleAuth(config?) {
  return axios.post(URL + `user/fa/item/bindGoogleAuth`, null, config);
}

//2fa  解绑定谷歌
export function post_unBindGoogleAuth(config?) {
  return axios.post(URL + `user/fa/item/unBindGoogleAuth`, null, config);
}

// 绑定邮箱
export function post_bindEmail(config?) {
  return axios.post(URL + `user/fa/item/bindEmail`, null, config);
}
// 修改绑定邮箱
export function post_updateBindEmail(config) {
  return axios.post(URL + `user/fa/item/updateBindEmail`, null, config);
}

//2fa  绑定手机
export function post_bindMobile(config?) {
  return axios.post(URL + `user/fa/item/bindMobile`, null, config);
}

//2fa  修改绑定手机
export function post_updateBindMobile(config?) {
  return axios.post(URL + `user/fa/item/updateBindMobile`, null, config);
}

//2fa  设置防钓鱼码
export function post_setAntiFishingCode(config?) {
  return axios.post(URL + `user/fa/item/setAntiFishingCode`, null, config);
}

//2fa  修改防钓鱼码
export function post_updateAntiFishingCode(config?) {
  return axios.post(URL + `user/fa/item/updateAntiFishingCode`, null, config);
}

//2fa  修改密码
export function post_updatePasswd(config) {
  return axios.post(URL + `user/fa/item/updatePasswd`, null, config);
}

//获取密码公钥
export function post_publicKey(config) {
  return axios.post(`/uaapi/uaa/authorize/passwd/publicKey`, null, config);
}

// 设置登录密码（第三方新用户首次设置，需带 Authorization）
export function post_setLoginPassword(config?: CustomAxiosRequestConfig) {
  return axios.post(URL + `user/setLoginPassword`, config?.data ?? null, config);
}

//用户账户 删除操作
export function delete_userClose(config) {
  return axios.delete(URL + `user/close`, config);
}

//用户账户 apiKey 添加
export function post_userAccountApiKeyAdd(config) {
  return axios.post(URL + `user/account/apikey/add`, null, config);
}

//用户账户 apiKey 删除
export function get_userAccountApiKeyDelete(config) {
  return axios.get(URL + `user/account/apikey/delete`, config);
}

//用户账户 apiKey 修改
export function post_userAccountApiKeyUpdate(config) {
  return axios.post(URL + `user/account/apikey/update`, null, config);
}

//用户账户 apiKey 列表
export function post_userAccountApiKeyListCurr(config) {
  return axios.get(URL + `user/account/apikey/listCurr`, config);
}

// 获取
export function get_getFa(config) {
  // return axios.get(URL + `user/fa`, config);
  return new Promise((resolve, reject) => {
    axios
      .get(URL + `user/fa`, config)
      .then((data) => {
        if (data && data.length) {
          const newData = data.filter((obj) => /^(EMAIL|MOBILE|GA)$/i.test(obj.type));
          resolve(newData);
        } else {
          resolve(data);
        }
      })
      .catch(reject);
  });
}

// 更新 /user/fa
export function put_getFa(config) {
  return axios.put(URL + `user/fa`, null, config);
}
// 删除fa
export function delete_getFa(config) {
  return axios.delete(URL + `user/fa`, config);
}

//获取用户 passkey 列表
export function get_passkey(config?) {
  return axios.get(URL + `user/passkey`, config);
}

//更新用户 passkey
export function put_passkey(config?) {
  return axios.put(URL + `user/passkey`, null, config);
}

//删除用户 passkey
export function delete_passkey(config?) {
  return axios.delete(URL + `user/passkey`, config);
}

//用户 passkey 开始
export function post_passkeyRegistrationBegin(config?) {
  return axios.post(URL + `user/passkey/registration-begin`, null, config);
}

//用户 passkey 结束
export function post_passkeyRegistrationFinish(config?) {
  return axios.post(URL + `user/passkey/registration-finish`, null, config);
}

// 获取初始化昵称+头像数据
export function getNickAndImg(config?) {
  return axios.get(URL + `user/sub-account/nick-img`, config);
}

// 修改昵称
export function putNickName(config?: CustomAxiosRequestConfig) {
  return axios.put(URL + `user/sub-account/nick-name`, null, config);
}

// 修改头像
export function postHeadImg(config?: CustomAxiosRequestConfig) {
  return axios.post(URL + `user/sub-account/head-img`, null, config);
}

// 获取预设头像列表
export function getAvatarList(config?: CustomAxiosRequestConfig) {
  return axios.get(URL + `user/avatarList`, config);
}

// 新接口：合并修改昵称和头像
export function putUpdateProfile(config?: CustomAxiosRequestConfig) {
  return axios.put(URL + `user/updateProfile`, null, config);
}

// 上传头像
export function postFileUpload(config?: CustomAxiosRequestConfig) {
  return axios.post(URL + `file/upload`, null, config);
}

// 保存头像地址
export function postSaveHeadImg(config?: CustomAxiosRequestConfig) {
  return axios.post(URL + `user/sub-account/head-img`, null, config);
}

// 获取头像昵称状态是否为审核中
export function getUserDataStatus(config?) {
  return axios.get(URL + `user/sub-account/user-data-status`, config);
}

//2fa 单项验证检查
export function get_faCheckSendCode(config?) {
  return axios.get(URL + `user/fa/checkSendCode`, config);
}

//2fa 校验结果V2
export function get_faGetFaResultV2(config?) {
  return axios.get(URL + `user/fa/getFaResultV2`, config);
}

// 根据国家获取验证方式
export function getAuthType(config?) {
  return axios.get(URL + `user/kyc/v2/auth-type`, config);
}

// 获取accessToken
export function getAuthAccess(config?) {
  return axios.get(URL + `user/kyc/v2/auth-access`, config);
}

// 新实名认证接口
export function postHumanAuth(config?) {
  return axios.post(URL + `user/kyc/v2/human-auth`, null, config);
}
